import { useEffect, useRef } from 'react';

import useJohnDeere from 'hooks/useJohnDeere';
import useJohnDeereOrganizations from 'hooks/useJohnDeereOrganizations';

const useData = () => {
    const { connect, disconnect, isConnected, isConnecting } = useJohnDeere();
    const { fetch, isLoading, organizations } = useJohnDeereOrganizations();
    const hasFetchedOrgs = useRef(false);

    useEffect(() => {
        if (!isConnected || hasFetchedOrgs.current) {
            return;
        }

        hasFetchedOrgs.current = true;
        fetch();
    }, [isConnected, fetch]);

    return {
        connect,
        disconnect,
        isConnected,
        isConnecting,
        isLoading,
        organizations
    };
};

export default useData;
